
































import { Component, Vue, Prop } from 'vue-property-decorator';
import { currency } from '@/utils/filters';
import { CartRetailerSection } from '@/models/cart';

@Component({
  filters: {
    currency,
  },
})
export default class DmqCartRetailerSummary extends Vue {

  @Prop()
  private retailerSection!: CartRetailerSection;

  private get deliveryFeesValue() {
    return this.retailerSection.deliveryMode === 'delivery' ?
      currency(this.retailerSection.intendedDeliveryFees, 'CHF') :
      '--.--';
  }

}

